import usePayment from "../hook/usePayment"
import PaymentMainLayout from "../components/PaymentMainLayout";

function PaymentPage() {
    const prop = usePayment();
    return <PaymentMainLayout {...prop} />
}
export default PaymentPage